import { render, staticRenderFns } from "./SolutionListView.vue?vue&type=template&id=5ffa3ed9"
import script from "./SolutionListView.vue?vue&type=script&lang=js"
export * from "./SolutionListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports